function closeAllSubMenus({ event }) {
  if (event.pointerType !== 'mouse') return;

  const navMain = document.getElementById('navMain');
  const subMenus = navMain.querySelectorAll('.navMain-subMenu');
  subMenus.forEach((subMenu) => {
    subMenu.setAttribute('aria-hidden', true);
    subMenu.classList.remove('is-open');
  });
}

function openSubMenu({ event, menuItem }) {
  if (event.pointerType !== 'mouse') return;

  const subMenu = menuItem.querySelector('.navMain-subMenu');
  if (subMenu) {
    closeAllSubMenus({ event });
    subMenu.setAttribute('aria-hidden', false);
    subMenu.classList.add('is-open');
  }
}

function toggleSubMenu({ menuItem }) {
  const navMain = document.getElementById('navMain');
  const subMenus = navMain.querySelectorAll('.navMain-subMenu');
  subMenus.forEach((subMenu) => {
    subMenu.setAttribute('aria-hidden', true);
    subMenu.classList.remove('is-open');
  });

  const subMenu = menuItem.querySelector('.navMain-subMenu');
  if (subMenu) {
    const isHidden = subMenu.getAttribute('aria-hidden') !== 'false';

    subMenu.setAttribute('aria-hidden', isHidden ? 'false' : 'true');
    if (isHidden) {
      subMenu.classList.toggle('is-open');
    } else {
      subMenu.classList.remove('is-open');
    }
  }
}

function toggleHambugerMenu() {
  const hamburgerButton = document.getElementById('hamburger');
  const headerMainMenu = document.getElementById('header-main-menu');

  const isHidden = hamburgerButton.getAttribute('aria-expanded') === 'false';
  hamburgerButton.setAttribute('aria-expanded', isHidden);
  headerMainMenu.setAttribute('aria-hidden', !isHidden);
  document.documentElement.classList.toggle('is-open');
}

const hasAnchorLink = (link) => {
  if (link.href.indexOf('#') > -1) {
    return true;
  }
  return false;
};

function initialiseSubmenuItems({ subMenu }) {
  const subMenuItems = subMenu.querySelectorAll('.menu-item a');

  subMenuItems.forEach((subMenuItem) => {
    if (hasAnchorLink(subMenuItem)) {
      subMenuItem.addEventListener('click', () => {
        const hamburgerButton = document.getElementById('hamburger');
        const isHamburgerHidden =
          hamburgerButton.getAttribute('aria-expanded') === 'false';

        if (!isHamburgerHidden) {
          toggleHambugerMenu();
        }
      });
    }
  });
}

function initialiseDropdownArrow({ menuItem }) {
  const dropdownButton = menuItem.querySelector('.link-arrow');
  if (dropdownButton) {
    dropdownButton.addEventListener('click', (event) => {
      event.preventDefault();
      toggleSubMenu({ menuItem });
    });
  }
}

function initialiseMenuItem({ menuItem }) {
  const subMenu = menuItem.querySelector('.navMain-subMenu');
  if (subMenu) {
    subMenu.setAttribute('aria-hidden', 'true');

    initialiseDropdownArrow({ menuItem });

    menuItem.addEventListener('pointerover', (event) => {
      openSubMenu({ event, menuItem });
    });

    menuItem.addEventListener('pointerout', (event) => {
      if (!menuItem.contains(event.relatedTarget)) {
        closeAllSubMenus({ event });
      }
    });

    initialiseSubmenuItems({ subMenu });
  }
}

function init() {
  const navMain = document.getElementById('navMain');
  const menuItems = navMain.querySelectorAll('.menu-item-has-children');
  menuItems.forEach((menuItem) => {
    initialiseMenuItem({ menuItem });
  });
}

export default {
  init,
};
